import { useContext } from 'react'

import { UserDetailsContext } from 'src/context/userDetailsContext'

export function useOrganization() {
    const {
        userDetails: { organization },
    } = useContext(UserDetailsContext)

    return organization
}
